angular.module('dpw.components')

    .component('dpwEditProfile', {
        templateUrl: 'dpw-edit-profile.html',
        controller: ['$location', 'user', 'popupUtil', 'freeTierService', 'helpers',
            function ($location, user, popupUtil, freeTierService, helpers) {
                var $ctrl = this;

                $ctrl.$onInit = function () {
                    user.fetch().then(function () {
                        if (!freeTierService.isFreeAccount(user.getUser())) {
                            $location.path('/');
                            return;
                        }

                        $ctrl.isUserAccessible = true;
                    });
                };

                // TODO: Can be improved - Use a class to organize the forms.
                $ctrl.formsConfig = (function () {
                    var formsConfig = {
                        basicInfo: {
                            formName: 'basicInfoForm',
                            className: 'dpw-edit-profile-basic-info-form'
                        },
                        securityInfo: {
                            formName: 'securityInfoForm',
                            className: 'dpw-edit-profile-security-info-form'
                        }
                    };

                    _.forEach(formsConfig, function (formConfig) {
                        formConfig.getFormCtrl = function () {
                            var formScope = angular.element('.' + formConfig.className).scope();
                            return _.get(formScope, formConfig.formName);
                        };

                        _.assign(formConfig, buildFormUtils(formConfig));
                    });

                    return formsConfig;
                })();

                $ctrl.onFieldChange = function (formConfig, fieldConfig, componentCtrl) {
                    var fieldCtrl = _.get(formConfig.getFormCtrl(), fieldConfig.fieldName);
                    var profile = componentCtrl.profile;

                    var validation = fieldConfig.validation;
                    if (validation) {
                        var fieldValue = _.get(profile, fieldConfig.keyName);

                        // The situation when the value is empty is handled by other form validation mechanism.
                        var isValid = _.isEmpty(fieldValue) ? true : validation.validator(fieldValue);

                        if (fieldCtrl) {
                            formConfig.setFieldStatus(fieldConfig.fieldName, '$setValidity', [validation.errorKey, isValid]);

                            if (isValid) {
                                _.remove(fieldConfig.fieldErrors, function (errorCode) {
                                    return errorCode === validation.errorCode;
                                });
                            } else {
                                !_.includes(fieldConfig.fieldErrors, validation.errorCode) && fieldConfig.fieldErrors.push(validation.errorCode);
                            }
                        }
                    }

                    $ctrl.dirtyCheck.perform(formConfig, componentCtrl);
                };

                $ctrl.markFieldInvalid = function (formConfig, fieldConfig, errorCode) {
                    var fieldCtrl = _.get(formConfig.getFormCtrl(), fieldConfig.fieldName);
                    var fieldErrors = fieldConfig.fieldErrors;

                    if (fieldCtrl) {
                        markFieldInvalid();
                        clearTheMarkOnFieldChange();
                    }

                    function markFieldInvalid() {
                        formConfig.setFieldStatus(fieldConfig.fieldName, '$setValidity', [errorCode, false]);
                        !_.includes(fieldErrors, errorCode) && fieldErrors.push(errorCode);
                    }

                    function clearTheMarkOnFieldChange() {
                        var onChangeFn = fieldConfig.onChange;

                        fieldConfig.onChange = function () {
                            formConfig.setFieldStatus(fieldConfig.fieldName, '$setValidity', [errorCode, true]);
                            _.remove(fieldErrors, function (code) {
                                return code === errorCode;
                            });

                            fieldConfig.onChange = onChangeFn;

                            fieldConfig.onChange();
                        };
                    }
                };

                $ctrl.buildHandlerAction = function (formConfig) {
                    return function (fieldConfig, errorCode) {
                        $ctrl.markFieldInvalid(formConfig, fieldConfig, errorCode);
                    };
                };

                $ctrl.errorDispatcher = function (data, extraHandlerConfig, defaultErrorHandler) {
                    var handlerConfig = {
                        'TOO_MANY_REQUESTS': function () {
                            popupUtil.ok({
                                content: RCDPW.Lang.EditProfile.SERVICE_UNAVAILABLE
                            });
                        }

                        // Definitions for both "Basic Info" form and "Security Info" form go here.

                    };

                    _.assign(handlerConfig, extraHandlerConfig);

                    var errorResult = helpers.resolveError(data);
                    _.result(handlerConfig, errorResult.code, defaultErrorHandler);
                };

                $ctrl.dirtyCheck = {
                    formStatus: {},
                    perform: function (formConfig, componentCtrl) {
                        var profile = componentCtrl.profile;
                        var originalProfile = componentCtrl.originalProfile;
                        var isDirty = !angular.equals(profile, originalProfile);

                        this.formStatus[formConfig.formName] = isDirty;

                        RCDPW.isEditProfileFormDirty = _.some(this.formStatus, function (isFormDirty) {
                            return isFormDirty === true;
                        });
                    },
                    updateData: function (componentCtrl, changeSet) {
                        _.assign(componentCtrl.profile, changeSet);
                        _.assign(componentCtrl.originalProfile, changeSet);
                    }
                };

                function buildFormUtils(formConfig) {
                    return {
                        getFormStatus: function (statusKey) {
                            return _.get(formConfig.getFormCtrl(), statusKey);
                        },
                        setFormStatus: function (fnName, args) {
                            var formCtrl = formConfig.getFormCtrl();
                            var setterFn = _.get(formCtrl, fnName, angular.noop);
                            setterFn.apply(formCtrl, args);
                        },
                        getFieldStatus: function (fieldName, statusKey) {
                            return _.get(formConfig.getFormCtrl(), [fieldName, statusKey]);
                        },
                        setFieldStatus: function (fieldName, fnName, args) {
                            var fieldCtrl = _.get(formConfig.getFormCtrl(), fieldName);
                            var setterFn = _.get(fieldCtrl, fnName, angular.noop);
                            setterFn.apply(fieldCtrl, args);
                        },
                        setFieldsStatus: function (fnName, args) {
                            _.forEach(formConfig.getFormCtrl(), function (fieldCtrl) {
                                var setterFn = _.get(fieldCtrl, fnName, angular.noop);
                                setterFn.apply(fieldCtrl, args);
                            });
                        }
                    };
                }
            }]
    })

;
